<template>
	<div class="my-idicare">
		<h1>{{ $t('labels.general.my_idicare') }}</h1>
		<div class="avatar">
			<avatar-picture-user/>
			<div class="name">{{ user.fullname }}</div>
			<div class="account-type">{{ $t('labels.general.account_personal') }}</div>
		</div>
		<div class="links">
			<router-link :to="{ name: 'UserProfileAccount', params: { user_uid: user_uid } }">
				<svgicon name="user" :fill="false"></svgicon>
				<span>{{ $t('labels.general.account') }}</span>
				<svgicon name="user" :fill="false"></svgicon>
			</router-link>
			<router-link :to="{ name: 'AuthLogout' }">
				<svgicon name="logout" :fill="false"></svgicon>
				<span>{{ $t('base.auth.logout') }}</span>
				<svgicon name="logout" :fill="false"></svgicon>
			</router-link>
		</div>
		<locale-flag-selector/>
	</div>
</template>

<script>
import LocaleFlagSelector from '@/components/i18n/LocaleFlagSelector'
export default {
	components: {
		LocaleFlagSelector
	},
	props: [
		'user_uid'
	],
	computed: {
		user () {
			return this.$store.getters.getUser
		}
	},
	beforeCreate () {
		this.$title('My Idicare')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/page/MyIdicare.vue